import { FormControl, styled } from '@mui/material';

export const DataAccessAgreementControl = styled(FormControl)(() => ({
  '& p': {
    margin: 0,
  },
}));
